import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  IndexRouteProps,
} from "react-router-dom";

import { app_base_url } from "../Utils/baseUrl";
import { Inicio } from "../Pages/Cartorio_Pages/App_Pages/Inicio";
import { Funcionarios } from "../Pages/Cartorio_Pages/App_Pages/Funcionarios";
import { Perfil } from "../Pages/Cartorio_Pages/App_Pages/Perfil";
import { Imoveis } from "../Pages/Cartorio_Pages/App_Pages/Imoveis";
import { Prefeituras } from "../Pages/Cartorio_Pages/App_Pages/Prefeituras";
import { Funcionario_Perfil } from "../Pages/Cartorio_Pages/App_Pages/Funcionario_Perfil";
import { OperacaoProvider } from "../Hooks/operacoes";
import { FuncionarioCartorioProvider } from "../Hooks/funcionarioCartorio";
import { Operacoes } from "../Pages/Cartorio_Pages/App_Pages/Operacoes";
import { ImovelFocus } from "../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import { PrefeituraPerfil } from "../Pages/Cartorio_Pages/App_Pages/PrefeituraPerfil";
import { FuncionarioPrefeituraProvider } from "../Hooks/funcionarioPrefeitura";
import { ImoveisPrefeitura } from "../Pages/Cartorio_Pages/App_Pages/ImoveisPrefeitura";
import { Cartorios } from "../Pages/Cartorio_Pages/App_Pages/Cartorios";
import { ComunicacaoProvider } from "../Hooks/comunicacoes";
import { ImovelProvider } from "../Hooks/imoveis";
import { ImovelFocusRural } from "../Pages/Cartorio_Pages/App_Pages/ImovelFocusRural";
import { ImoveisRurais } from "../Pages/Cartorio_Pages/App_Pages/ImoveisRurais";
import { ImoveisPrefeituraRural } from "../Pages/Cartorio_Pages/App_Pages/ImoveisPrefeituraRural";
import { Relatorios } from "../Pages/Cartorio_Pages/App_Pages/Relatorios";
import { TransmitenteProvider } from "../Storage/Transmitente";
import { AdquirinteProvider } from "../Storage/Adquirente";
import { SupportLogo } from "../Components/Suporte";

export function Funcionario_PrefeituraRoutes() {
  return (
    <ImovelProvider>
      <FuncionarioPrefeituraProvider>
        <ComunicacaoProvider>
          <OperacaoProvider>
            <TransmitenteProvider>
              <AdquirinteProvider>
                <Router>
                <SupportLogo />
                  <Routes>
                    <Route
                      path={`${app_base_url}/perfil`}
                      element={<Funcionario_Perfil />}
                    ></Route>

                    <Route
                      path={`${app_base_url}/imoveis`}
                      element={<ImoveisPrefeitura />}
                    ></Route>

                    <Route
                      path={`${app_base_url}/cartorios`}
                      element={<Cartorios />}
                    ></Route>

                    <Route
                      path={`${app_base_url}/imovel/:id`}
                      element={<ImovelFocus />}
                    ></Route>
                    <Route
                      path={`${app_base_url}/imoveis-rurais`}
                      element={<ImoveisPrefeituraRural />}
                    ></Route>
                    <Route
                      path={`${app_base_url}/imovel-rural/:id`}
                      element={<ImovelFocusRural />}
                    ></Route>
                    <Route
                      path={`${app_base_url}/relatorios`}
                      element={<Relatorios />}
                    ></Route>

                    <Route
                      path={`${app_base_url}/redirecionamento/:destino`}
                      element={<Inicio />}
                    ></Route>
                    <Route
                      path={`${app_base_url}*`}
                      element={<Inicio />}
                    ></Route>
                  </Routes>
                </Router>
                </AdquirinteProvider>
            </TransmitenteProvider>
          </OperacaoProvider>
        </ComunicacaoProvider>
      </FuncionarioPrefeituraProvider>
    </ImovelProvider>
  );
}
